import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import { Link } from "react-router-dom";
import { solutionListing } from "api/CategoryService";
import { Sentry } from "react-activity";
import Loader from "components/Loader";
const Solutions = () => {
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 12;
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await solutionListing(page, limit);
      if (page === 1) {
        setCategories(res.body.data); // reset
      } else {
        setCategories((prev) => [...prev, ...res.body.data]); // append
      }
      setTotalPages(res.body.total_pages);
    } catch (err) {
      console.error("Error fetching solution list", err);
    } finally {
      setLoading(false);
      setPageLoading(false);
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories(); // Load on page change
  }, [page]);

  const loadMore = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };
  return pageLoading ? (
    <div className="loaderdiv">
      {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
      <Loader />
    </div>
  ) : (
    <>
      <React.Fragment>
        {/* BreadCrumb Section */}
        <BreadcrumbSection
          breadcrumbs={[
            {
              title: "Solutions",
            },
          ]}
        />

      <section className="software_section py-5">
        <Container>
          <Row className="mb-4">
            <Col lg={12}>
              <div className="software_header mb-3">
                <h2>Solutions</h2>
              </div>
            </Col>
            <Col lg={12}>
              {initialLoading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <Row>
                  {categories.map((category, index) => (
                    <Col
                      key={index}
                      xs={12}
                      sm={6}
                      md={6}
                      lg={6}
                      className="mb-4"
                    >
                      <Card className="solution_Items">
                        <Card.Body
                          as={Link}
                          to={category.slug}
                          state={{ resource: category }}
                        >
                          {category.title}{" "}
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_515_5255)">
                              <path
                                d="M7.88442 18.8051C7.37186 19.3073 7.37186 20.1213 7.88442 20.6234C8.39699 21.1255 9.22801 21.1255 9.74058 20.6234L17.6156 12.9091C18.1281 12.407 18.1281 11.593 17.6156 11.0909L9.74058 3.37658C9.22801 2.87447 8.39699 2.87447 7.88442 3.37658C7.37186 3.87868 7.37186 4.69275 7.88442 5.19485L14.8313 12L7.88442 18.8051Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_515_5255">
                                <rect
                                  width="24"
                                  height="24"
                                  fill="white"
                                  transform="matrix(0 -1 1 0 0 24)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}

                    {page < totalPages && (
                      <Col md={12}>
                        <div className="centerbtn">
                          <Button
                            variant="outline-primary"
                            className="iconFlex border-radius-100"
                            onClick={loadMore}
                            disabled={loading}
                          >
                            {loading ?   <Spinner animation="border" size="sm" /> : "Load More"}
                          </Button>
                        </div>
                      </Col>
                    )}
                  </Row>
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    </>
  );
};

export default Solutions;
